import { render, staticRenderFns } from "./ManagePermissions.vue?vue&type=template&id=7fc151f7&scoped=true&"
import script from "./ManagePermissions.vue?vue&type=script&lang=js&"
export * from "./ManagePermissions.vue?vue&type=script&lang=js&"
import style0 from "./ManagePermissions.vue?vue&type=style&index=0&id=7fc151f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc151f7",
  null
  
)

export default component.exports